import { useQuery } from '@tanstack/react-query';
import dailySiteReportService from '@services/dailySiteReport';
import { useAppSelector } from '@redux/hooks';
import { RootState } from '@redux/store';

export const DAILY_SITE_REPORT_AVAILABLE_QUERY_KEY = 'dailySiteReportAvailable';

/** Sprint 33, story-169/170. Clone of `useAssistantAvailable` — no permission gate on the
 * backend query, long `staleTime` since this rarely flips within a session. */
export const useDailySiteReportAvailable = () => {
  const { organizationId } = useAppSelector((state: RootState) => state.organization);

  return useQuery({
    queryKey: [DAILY_SITE_REPORT_AVAILABLE_QUERY_KEY, organizationId],
    queryFn: () => dailySiteReportService.getDailySiteReportAvailable(),
    enabled: !!organizationId,
    staleTime: 10 * 60 * 1000,
    retry: false,
  });
};

export default useDailySiteReportAvailable;
